// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group[data-v-6e08db20]{margin-bottom:25px}.form-group label[data-v-6e08db20]{color:var(--dark)}", ""]);
// Exports
module.exports = exports;
